export default __webpack_public_path__ + "static/media/oops.44ad4c9a.jpeg";